// extracted by mini-css-extract-plugin
export default {"label":"ci_label__2+wTh","c":"ci_c__A5hDn"};